import { ReactNode } from "react";

interface EmptyFieldProps {
  children: ReactNode;
  className?: string;
}

export const EmptyField = ({ children, className = "" }: EmptyFieldProps) => (
  <span className={`text-gray-400 italic text-sm ${className}`}>
    {children}
  </span>
);
